import axios from 'axios';
import {
    SET_FETCH_DEPLOYED_REGIONS_REQUEST,
    SET_FETCH_DEPLOYED_REGIONS_SUCCESS,
    SET_FETCH_DEPLOYED_REGIONS_ERROR,
} from './../../../../constants/closeLoop/apmDashboard/regions/regionsConstants';


export const fetchDeployedRegions = () => (dispatch) => {
    try {
        dispatch({type: SET_FETCH_DEPLOYED_REGIONS_REQUEST});
        const url = '/close_loop/deployed/regions';
        axios.get(url).then((response) => {
            if(response && response.status === 200) {
                dispatch({type: SET_FETCH_DEPLOYED_REGIONS_SUCCESS, payload: response.data});
            } else {
                dispatch({type: SET_FETCH_DEPLOYED_REGIONS_ERROR, payload: response.message});
            }
        }).catch((error) => {
            console.error(error);
            dispatch({
                type: SET_FETCH_DEPLOYED_REGIONS_ERROR,
                payload: error.response.data.message
            });
        })
    } catch(error) {
        console.error(error);
        dispatch({type: SET_FETCH_DEPLOYED_REGIONS_ERROR, payload: error.message});
    }
}